import MainLayout from "@/components/layout/admin/MainLayout.vue";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import CONFIG from "@/assets/js/config.js";
import AdvancedLaravelVuePaginate from 'advanced-laravel-vue-paginate';
import 'advanced-laravel-vue-paginate/dist/advanced-laravel-vue-paginate.css';
import axios from 'axios';
import HandlePaginateService from "@/services/HandlePaginateService";
import Select2Multiple from 'v-select2-multiple-component';
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';

export default {
  name: "leaveBalanceList",
  components: {
    MainLayout,
    Select2Multiple,
    flatPickr,
    Loading,
    CONFIG,
    AdvancedLaravelVuePaginate
  },

  data() {
    return {
      leaveBalanceLists: {},
      total: null,
      isLoading: false,
      currentPage: 1,
      noDataMsg: CONFIG.NO_DATA_FOUND,
      search_status: false,
      searchBtnStatus: false,
      searchedData: null,
      isSearched: false,
      usedLeftOptions: [
        { id: 'left', text: 'Left' },
        { id: 'used', text: 'Used' },
      ],
      allResetOptions: [
        { id: 'all', text: 'All' },
        { id: 'reset', text: 'Reset' },
      ],
      searchData: {
        employee_no: '',
        employee_name: '',
        cut_off_date: '',
        used_left: 'left',
        all_reset: 'all',
      },
    };
  },

  methods: {
    getLeaveBalanceLists(page = 1) {
      this.currentPage = page;
      this.isLoading = true;
      this.search_status = false;
      axios.get('/leave-balance/list?page=' + page)
        .then((response) => {
          this.leaveBalanceLists = response.data;
        })
        .catch((err) => {
          if (err && err.response && err.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          } else {
            console.error(err);
          }
        })
        .finally(() => {
          this.isLoading = false;
        })
    },

    reset() {
      this.searchData.employee_no = '';
      this.searchData.employee_name = '';
      this.searchData.cut_off_date = '';
      this.searchData.used_left = 'left';
      this.searchData.all_reset = 'all';
      this.isLoading = true;
      this.isSearched = false;
      this.getLeaveBalanceLists();
    },

    onUsedLeftChange() {
      if (this.searchData.used_left === 'left') {
        this.searchData.cut_off_date = '';
      } else {
        this.searchData.cut_off_date = '';
      }
    },

    searchLeaveBalance(page = 1) {
      this.currentPage = page;
      this.searchBtnStatus = true;
      this.isLoading = true;
      var request = {
        params: {
          employee_no: this.searchData.employee_no,
          employee_name: this.searchData.employee_name,
          cut_off_date: this.searchData.cut_off_date,
          used_left: this.searchData.used_left,
          all_reset: this.searchData.all_reset,
        }
      }

      this.searchedData = {
        ...request.params,
        search_status: this.searchBtnStatus
      };
      this.isSearched = true;
      axios.get("/leave-balance/search?page=" + page, request)
        .then(response => {
          this.search_status = true;
          this.leaveBalanceLists = response.data;
          this.isLoading = false;
        })
        .catch(error => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
          console.log("Leave Balance Search API Error", error);
        });
    },

    showEdit(item) {
      this.$router.push({
        name: "leaveBalanceEdit",
        params: {
          owner_id: item.owner_id,
          owner_type: item.employee_type
        }
      });
    },

    resetSickLeave(item) {
      if (confirm('Are you sure you want to reset the sick leave for ' + item.employee_name + '?')) {
        axios.post('/leave-balance/resetSickLeave', {
          owner_id: item.owner_id,
          owner_type: item.employee_type 
        })
          .then(response => {
            if (response.data && response.data.success === true) {
              this.$notification.success('Reset Sick Leave Successfully.', {
                timer: 3,
                position: "bottomCenter"
              });
              this.reset();
              this.getLeaveBalanceLists(this.currentPage);
            } else {
              this.$notification.error(
                response.data?.message || 'Cannot reset sick leave now', {
                timer: 3,
                position: "bottomCenter",
              });
            }
          })
          .catch(error => {
            console.error("Reset Sick Leave Error", error);
            this.$notification.error('Failed to reset sick leave.', {
              timer: 3,
              position: "bottomCenter",
            });
          });
      }
    },

    resetLeave(item) {
      if (confirm('Are you sure you want to reset the leave balances for ' + item.employee_name + '?')) {
        axios.post('/leave-balance/resetLeave', {
          owner_id: item.owner_id,
          owner_type: item.employee_type
        })
          .then(response => {
            if (response.data && response.data.success === true) {
              this.$notification.success('Leave Balances Reset Successfully', {
                timer: 3,
                position: "bottomCenter"
              });
              this.reset();
              this.getLeaveBalanceLists(this.currentPage);
            } else {
              this.$notification.error(
                response.data?.message || 'Cannot reset leave now',
                {
                  timer: 3,
                  position: "bottomCenter",
                }
              );
            }
          })
          .catch(error => {
            console.error("Reset Leave Error", error);
            this.$notification.error('Failed to reset sick leave.', {
              timer: 3,
              position: "bottomCenter",
            });
          });
      }
    },

    formatResetDate(item) {
      if (item.annual_reset_date) {
        return item.annual_reset_date;
      } else {
        if (item.join_date) {
          let date = new Date(item.join_date);
          date.setFullYear(date.getFullYear() + 1);
          return date.toISOString().split('T')[0];
        }
      }
    },

    handlePaginate(page) {
      HandlePaginateService.paginate({
        page,
        isSearch: this.search_status,
        searchFn: this.searchLeaveBalance,
        listFn: this.getLeaveBalanceLists
      })
    },

    excelDownload() {
      this.isLoading = true;
      const params = this.isSearched && this.searchedData
        ? { ...this.searchedData }
        : {};
      axios.get('/leave-balance/excelDownload', {
        params,
        responseType: 'arraybuffer'
      })
        .then(response => {
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement('a');
          let date = new Date();
          fileLink.href = fileURL;
          fileLink.setAttribute('download', `leave_balance_list_${date.getFullYear()}${(date.getMonth() + 1) < 9 ? 0 : ''}${(date.getMonth() + 1)}${date.getDate() < 9 ? 0 : ''}${date.getDate()}.xlsx`);
          document.body.appendChild(fileLink);
          fileLink.click();
          this.isLoading = false;
        }).catch(error => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
        });
    },

  },

  mounted() {
    this.isLoading = true;
    this.getLeaveBalanceLists();
  },
};
